// extracted by mini-css-extract-plugin
export default {"root":"BundleHero-root","heading":"BundleHero-heading","body":"BundleHero-body"};